import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

const MaintenanceModuleFooter = () => {
    const { t } = useTranslation(['maintenance']);

    return (
        <Button form="updateMainDetails" htmlType="submit" type="primary">
            {t('maintenance:actions.update')}
        </Button>
    );
};

export default MaintenanceModuleFooter;
